'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M448 128c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448h-448v-448zM576 0v448h448c0-247.424-200.576-448-448-448z' })
    ));
};